import React, {useEffect, useState} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, NativeSelect, Grid, TextField, Button, IconButton } from '@material-ui/core';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useDispatch, useSelector } from "react-redux";
import { loadDepartures, changeAirport, changeDepartureDate, changeFlight, getEmailHistory } from "../../store/departures";
import RowItem from './RowItem';
import { SelectWithLabel } from '../../utils/selectWithLabel'
import _ from 'lodash';
import { CSVLink } from "react-csv";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: 'rgb(117,117,117,1)',
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  }
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },  
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  header: {
    backgroundColor: 'rgb(117,117,117,1)',
    borderRadius: '0px'
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  buttonCell: {
    width: '7%'
  }
}));

function createData(flightNum, departure, depTime, arrival, arrTime, key, closeFlight, statusKey, legKey, statusHref) {
  return {
    flightNum,
    departure,
    depTime,
    arrival,
    arrTime,
    key,
    closeFlight,
    statusKey, 
    legKey,
    statusHref
  };
}

export default function Departures() {
  const classes = useStyles()
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(25)
  const [flightStatusFilter, setFlightStatusFilter] = useState(['active', 'closed', 'checkInClosed'])
  const dispatch = useDispatch()
  const departures = useSelector(state => state.entities.departures.list)
  const depDate = useSelector(state => state.entities.departures.departureDate)
  const depAirport = useSelector(state => state.entities.departures.departureAirport)
  const flightNum = useSelector(state => state.entities.departures.flightNumber)
  const paxInfo = useSelector(state => state.entities.departures.paxInfo)

  useEffect(() => {
    dispatch(loadDepartures(depDate, depAirport, flightNum));
    dispatch(getEmailHistory(depDate))
  }, [depDate, depAirport, flightNum]);

  // NOTE // filters departures (just flightStatus (dep.flightStatusLeg.flightLegStatus). depDate, depAirport, and flightNum are query-params)
  const filterDeps = (deps) => {
    let filteredDeps = []

    // NOTE // looping over departures, getting the flightLegStatus object and looking if any of the matching filter values are true
    for (let i = 0; i < deps.length; i++) {
      const dep = deps[i];
      let depStatus = dep.flightStatusLeg.flightLegStatus
      for (let j = 0; j < flightStatusFilter.length; j++) {
        const filterVal = flightStatusFilter[j];
        if (depStatus[filterVal]) {
          filteredDeps.push(dep)
        }
      }
    }

    return _.cloneDeep(_.uniqBy(filteredDeps, 'key'))
  }

  // NOTE // paginates and formats departures into rows
  const paginateDepartures = () => {
    let paginatedDepartures = _.cloneDeep(departures)
    paginatedDepartures = filterDeps(paginatedDepartures)
    let start = page == 0 ? 0 : (page * rowsPerPage)
    paginatedDepartures = paginatedDepartures.slice(start, start + rowsPerPage)
    return paginatedDepartures
  }

  let rows = paginateDepartures().map(
    (depItem) => {
      const flightStatus = depItem.flightStatusLeg
      return createData(
        depItem.flightStatus.flightNumber, 
        flightStatus.departure.airport.code, 
        flightStatus.departure.localActualOutShortTime, 
        flightStatus.arrival.airport.code, 
        flightStatus.arrival.localActualOnShortTime, 
        depItem.key,
        flightStatus.flightLegStatus.closed,
        depItem.flightStatus.key,
        flightStatus.key,
        flightStatus.href
      )
    }
  ) || [];

  const getPageCount = () => {
    // NOTE // for the first page
    let page1 = `1-${departures.length < rowsPerPage ? departures.length : rowsPerPage} of ${departures.length}`
    // NOTE // for all proceeding pages
    let countStart = `${(page * rowsPerPage) + 1}`
    let countEnd = (page * rowsPerPage + rowsPerPage) < departures.length ? `${(page * rowsPerPage) + rowsPerPage + 1}` : `${departures.length}`
    let ofTotal = ` of ${departures.length}`
    let page2 = `${countStart}-${countEnd}${ofTotal}`
    return page == 0 ? page1 : page2
  }

  const airNorthAirports = [
    {label: 'None', value: ''},
    { label: "PHX", value: "PHX" },
    { label: "SVC", value: "SVC" },
    { label: "MMH", value: "MMH" },
    { label: "ABQ", value: "ABQ" },
    { label: "CLD", value: "CLD" },
    { label: "BUR", value: "BUR" },
    { label: "HHR", value: "HHR" },
    { label: "LAS", value: "LAS" },
    { label: "LAX", value: "LAX" },
    { label: "LRU", value: "LRU" },
    { label: "MCE", value: "MCE" },
    { label: "GUP", value: "GUP" },
    //{ label: "EDC", value: "EDC" },
    { label: "CNM", value: "CNM" },
    { label: "CEC", value: "CEC" },
    { label: "OAK", value: "OAK" },
    //added new departure cities
    { label: "AXX", value: "AXX" },
    //updated the HND -> HSH
    { label: "HSH", value: "HSH" },

  ];
// Sort the array excluding the "None" object
const sortedAirNorthAirports = airNorthAirports.filter(obj => obj.label !== 'None')
    .sort((a, b) => a.label.localeCompare(b.label));

// Append the "None" object at the end
sortedAirNorthAirports.push(airNorthAirports.find(obj => obj.label === 'None'));

  const taosAirports = [
    {label: 'None', value: ''},
    //{label: 'TSM', value: 'TSM'},
    // {label: 'AUS', value: 'AUS'},
    //{label: 'DAL', value: 'DAL'},
    {label: 'CLD', value: 'CLD'},
  ]

  const flightStatusChoices = [
    {label: 'Active', value: 'active'},
    {label: 'Cancelled', value: 'cancelled'},
    {label: 'Check-in Closed', value: 'checkInClosed'},
    {label: 'Closed', value: 'closed'},
    {label: 'Expired', value: 'expired'},
    {label: 'Locked', value: 'locked'}
  ]

  const handleChangePage = (direction) => {
    let newPage = page
    if (direction == 'forward') {
      newPage += 1
    }
    else if (newPage !== 0) {
      newPage -= 1
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const changeDepartureDateRq = (event) => {
    dispatch(changeDepartureDate(event.target.value))
  }

  const changeFlightRq = (event) => {
    dispatch(changeFlight(event.target.value))
  }

  const changeAirportRq = (event) => {
    dispatch(changeAirport(event.target.value))
  }

  const changeDateToLocal = (date) => {
    // NOTE // millis since epoch for the given date
    let epochTime = new Date(date).getTime()
    // NOTE // time difference between local and UTC in milliseconds
    let timezoneOffset = new Date().getTimezoneOffset() * 60000
    return new Date(epochTime - timezoneOffset)
  }

  const formatFlightDate = (dep, arr) => {
    let depDate = changeDateToLocal(dep).toString().slice(4, 21)
    let arrDate = changeDateToLocal(arr).toString().slice(4, 21)
    return depDate + ' - ' + arrDate
  }

  // NOTE // for the export-csv
  const formatBaggage = () => {
    let headers = [{label: 'flight number', key: 'flightNum'}, {label: 'aircraft', key: 'aircraft'}, {label: 'flight date', key: 'flightDate'}, {label: 'passenger name', key: 'paxName'}, {label: 'total bag weight', key: 'ttlBagWeight'}, {label: 'overweight bags', key: 'overWeightBags'}, {label: 'bag 1', key: 'bag1'}, {label: 'bag 2', key: 'bag2'}, {label: 'bag 3', key: 'bag3'}, {label: 'bag 4', key: 'bag4'}, {label: 'bag 5', key: 'bag5'}, {label: 'bag 6', key: 'bag6'}, {label: 'bag 7', key: 'bag7'}, {label: 'bag 8', key: 'bag8'}, {label: 'bag 9', key: 'bag9'}, {label: 'bag 10', key: 'bag10'}]
    let data = []

    if (paxInfo?.length) {
      // NOTE // getting departures that have passengers
      let paxCopy = _.cloneDeep(paxInfo).filter(dep => dep.passengers != null)
      for (let i = 0; i < paxCopy.length; i++) {
        const dep = paxCopy[i];
        let flightNum = dep.flightStatus.flightNumber
        let flightDate = formatFlightDate(dep.flightStatusLeg.departure.estimatedTime, dep.flightStatusLeg.arrival.estimatedTime)
        let aircraft = dep.flightStatusLeg.aircraftModel.name
        // NOTE // looping over passengers
        for (let j = 0; j < dep.passengers.length; j++) {
          const pax = dep.passengers[j];
          const paxBags = pax.passengerJourneyDetail.bags
          // NOTE // only using passengers that have baggage
          if (paxBags) {
            let paxName = formatName([pax.profile.firstName, pax.profile.lastName])
            // NOTE // looping over bags
            let overWeightBags = 0
            let ttlBagWeight = 0
            let bags = []
            for (let k = 0; k < paxBags.length; k++) {
              const bag = paxBags[k];
              // NOTE // this looks stupid, but it works. (1 + true = 2, 1 + false = 1)
              overWeightBags += (bag.weight.amount >= 50)
              ttlBagWeight += bag.weight.amount
              bags.push(`weight:${bag.weight.amount} type:${getBaggageType(bag.baggageType)}`)
            }
            data.push({flightNum: flightNum, flightDate: flightDate, aircraft: aircraft, paxName: paxName, ttlBagWeight: ttlBagWeight, overWeightBags: overWeightBags, bag1: bags[0], bag2: bags[1] || null, bag3: bags[2] || null, bag4: bags[3] || null, bag5: bags[4] || null, bag6: bags[5] || null, bag7: bags[6] || null, bag8: bags[7] || null, bag9: bags[8] || null, bag10: bags[9] || null })
          }
        }
      }
    }

    return {headers: headers, data: _.uniqWith(data, _.isEqual), filename: `${depDate} baggage.csv`}
  }

  const formatName = (nameArr) => {
    for (let i = 0; i < nameArr.length; i++) {
      let name = nameArr[i];
      name = name.toLowerCase()
      let nna = name.split('')
      nna[0] = nna[0].toUpperCase()
      nameArr[i] = nna.join('')
    }
    return nameArr.join(' ')
  }

  const getBaggageType = (baggageType) => {
    if (baggageType.carry) {
      return 'carry-on'
    }
    else if (baggageType.regular) {
      return 'regular'
    }
    else {
      return 'valet'
    }
  }

  const csvBaggage = formatBaggage()

  return (
    <div>
      <Grid container xs={12} style={{marginBottom: '15px'}}>
        <Grid item xs={9}>
        <form className={classes.container} noValidate>
          <TextField
            id="depDate"
            label="Departure Date"
            type="date"
            defaultValue={depDate}
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={changeDepartureDateRq}
          />
          <TextField
            id="flightNum"
            label="Flight Number"
            type="text"
            defaultValue={flightNum}
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={changeFlightRq}
          />
          <SelectWithLabel defaultVal={flightStatusFilter} handleChange={(e) => {setFlightStatusFilter(e.target.value)}} inputLabel={'Flight Status'} items={flightStatusChoices} multiple={true} />
          <SelectWithLabel defaultVal={depAirport} handleChange={changeAirportRq} inputLabel={'Airport'} items={_.uniqBy(sortedAirNorthAirports.concat(taosAirports),'value')}/>
        </form>
        </Grid>
        <Grid item xs={3}>
          <Button variant="contained" size="small">
            <CSVLink {...csvBaggage} style={{textDecoration: 'none', color: 'black'}}>Export Baggage</CSVLink>
          </Button>
        </Grid>
      </Grid>
      <Paper className={classes.root}>
        <TableContainer >
          <Table aria-label="collapsible table">
            <TableHead className={classes.header}>
              <TableRow >
                <StyledTableCell className={classes.buttonCell}>Pax</StyledTableCell>
                <StyledTableCell className={classes.buttonCell}>Actions</StyledTableCell>
                <StyledTableCell>
                  <Grid item xs={12}>Flight Number</Grid>
                  <Grid item xs={12}>Checked In</Grid>
                </StyledTableCell>
                <StyledTableCell>Departure</StyledTableCell>
                <StyledTableCell>Local Dep Time</StyledTableCell>
                <StyledTableCell>Arrival</StyledTableCell>
                <StyledTableCell>Local Arr Time</StyledTableCell>
                {/* NOTE // AN wants to hide this for now
                "Not sure if this is related to GDS pax being marked boarded and then flight closed and them not having a flown ticket status - I think think that's what we have in with Amelia right now. I think we figured out that there were a couple times where whoever was working the flight in fred actually hit the close flight button and then unchecked it to open back up before all the statuses would update to boarded" */}
                {/* <StyledTableCell>Close Flight</StyledTableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <RowItem key={row.name} row={row} index={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container justify="flex-end">
          <Grid item xs={7}></Grid>
          <Grid container justify="flex-end" item xs={5}>
            <Grid item xs={3}>
              <p>Rows Per Page:</p>
            </Grid>
            <Grid container alignContent="center" item xs={2}>
              <NativeSelect onChange={handleChangeRowsPerPage} value={rowsPerPage} inputLabel={'Rows Per Page'}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={100}>100</option>
              </NativeSelect>
            </Grid>
            <Grid container alignContent="center" item xs={2}>
              {getPageCount()}
            </Grid>
            <Grid container alignContent="center" item xs={1}>
              {
                page == 0 ? 
                <IconButton disabled>
                  <KeyboardArrowLeftIcon />
                </IconButton> :
                <IconButton aria-label="expand row" size="small" onClick={() => handleChangePage('back')}>
                  <KeyboardArrowLeftIcon/>
                </IconButton>
              }
            </Grid>
            <Grid container alignContent="center" item xs={1}>
              {
                ((page + 1) * rowsPerPage) >= departures.length ?
                <IconButton disabled>
                  <KeyboardArrowRightIcon />
                </IconButton> :
                <IconButton aria-label="expand row" size="small" onClick={() => handleChangePage('forward')}>
                  <KeyboardArrowRightIcon/>
                </IconButton>
              }
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
